import { exact, string } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const searchFieldType = exact({
  searchName: string.isRequired,
  row: string.isRequired,
  label: string.isRequired,
});
